import Link from 'src/components/navigation/link.component'
import { useTranslation } from 'react-i18next'
import AuthContainer from 'src/components/layouts/auth-container.component'
import { AuthLayout } from 'src/components/layouts/auth-layout.component'
import { CurecallButton } from '@honestica/curecall-ui'

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <AuthLayout isError>
      <AuthContainer>
        <h1 className="c-w-full c-text-start c-text-2xl c-font-bold c-text-black sm:c-text-start">
          {t('pages.not-found.page-not-found')}
        </h1>

        <p className="c-text-grey-700 c-text-base c-font-nexa c-font-light">
          {t('pages.not-found.page-not-found-info')}
        </p>
        {}
        <p className="c-text-grey-300 c-font-bold c-text-[80px] c-my-14 c-font-nexa">404</p>

        <div className="c-mt-8">
          <CurecallButton>
            <Link to="/" className="c-text-white hover:c-text-white">
              {t('pages.not-found.go-back-to-home')}
            </Link>
          </CurecallButton>
        </div>
      </AuthContainer>
    </AuthLayout>
  )
}
